


import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import MapObject from '@/interfaces/entities/map-object.interface';

@Component({})
export default class AppMapObjects extends Vue {

  @Prop()
  objects!: MapObject[];

  @Emit('select')
  public emitSelect(mapObject: MapObject): MapObject {
    return mapObject;
  }

  constructor() {
    super();
  }

  public select(mapObject: MapObject): void {
    this.emitSelect(mapObject);
  }
}
